import React, { useContext } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { ProductContext } from "../components/context/Context";

const Shop = (props) => {
  const { id, title, img, price, discountPrice, inCart } = props.product;

  const { handleDetail, addToCart, openModal } = useContext(ProductContext);

  return (
    <>
      <div className="col-md-3 col-sm-6">
        <div className="single-shop-product">
          <div className="product-upper" onClick={() => handleDetail(id)}>
            <Link to="/details">
              <img src={img} alt="" />
            </Link>
          </div>
          <h2>
            <a href="" style={{ marginLeft: "2.5rem" }}>
              {title}
            </a>
          </h2>
          <div
            className="product-carousel-price"
            style={{ marginLeft: "2.5rem" }}
          >
            <ins>${price}</ins> <del>${discountPrice}</del>
          </div>

          <div className="product-option-shop">
            <button
              className="add_to_cart_button"
              rel="nofollow"
              disabled={inCart ? true : false}
              onClick={() => {
                addToCart(id);
                openModal(id);
              }}
            >
              {inCart ? (
                <span className="text-capitalize mb-0" disabled>
                  in Cart
                </span>
              ) : (
                <span>
                  <i className="fa fa-shopping-cart"></i> Add to cart
                </span>
              )}
            </button>
            <Link
              className="add_to_cart_button"
              to="/details"
              onClick={() => handleDetail(id)}
              //   disabled={inCart ? true : false}
            >
              Details
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

Shop.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    img: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.number,
    inCart: PropTypes.bool,
  }).isRequired,
};

export default Shop;
